import {ChangeDetectionStrategy, Component} from '@angular/core';
import {FormsModule} from '@angular/forms';
import {AnalyticsService} from '../../../services/analytics.service';

@Component({
    selector: 'app-public-fuel-calculator',
    standalone: true,
    imports: [FormsModule],
    templateUrl: './public-fuel-calculator.component.html',
    styleUrl: './public-fuel-calculator.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PublicFuelCalculatorComponent {
    distance = 500;
    litres = 42;
    price = 75;

    constructor(private analytics: AnalyticsService) {
        this.analytics.goalOnce('fuel_calculator_view', {context: 'fuel'});
    }

    onValueChange(): void {
        this.analytics.goalOnce('fuel_calculator_used', {context: 'fuel'});
    }

    consumption(): number {
        return this.distance > 0 && this.litres > 0
            ? Math.round((this.litres / this.distance) * 10000) / 100
            : 0;
    }

    totalCost(): number {
        return this.litres > 0 && this.price > 0 ? Math.round(this.litres * this.price * 100) / 100 : 0;
    }

    costPer100Km(): number {
        return this.distance > 0 ? Math.round((this.totalCost() / this.distance) * 10000) / 100 : 0;
    }

    format(value: number, digits = 0): string {
        return new Intl.NumberFormat('ru-RU', {maximumFractionDigits: digits}).format(value);
    }
}

